import {
  AeCodeEditor,
  AeEditStatus,
  IBreadcrumbProps,
  TopBreadcrumbs,
  useEditorStore,
  useEditorDataFetcher,
  useResetAfterExit,
} from '@diana/core';
import { Box, Stack, useTheme } from '@mui/material';
import { isEqual } from 'lodash';
import React from 'react';
import { useBuilderContentHeight } from '../../Support/useBuilderContentHeight';
import { useFlowBuilder2PageContext } from '../../Context/useFlowBuilder2PageContext';
import { InvalidateLayoutsModelAndContent } from './InvalidateModelAndContent';

export const AeViewContent = () => {
  const { palette } = useTheme();
  const { isLoading: isPageLoading } = useFlowBuilder2PageContext();
  const { isLoading, error } = useEditorDataFetcher();
  const height = useBuilderContentHeight();

  useResetAfterExit();

  const contentItemId = useEditorStore((store) => store.contentItemId);
  const setSelectedItemId = useEditorStore((store) => store.setSelectedItemId);
  const breadcrumbs = useEditorStore((store) => store.getBreadcrumbs(contentItemId), isEqual);
  const isLoadingAeContent = useEditorStore((store) => store.isLoadingAeContent);

  const onBreadcrumbClick = (item: IBreadcrumbProps) => {
    if (item.id) {
      setSelectedItemId(item.id);
    }
  };

  return (
    <Stack gap={1} height={height}>
      <TopBreadcrumbs
        breadcrumbs={breadcrumbs}
        isLoading={isLoading || isPageLoading}
        onClick={onBreadcrumbClick}
      />
      <Box
        position="relative"
        sx={{
          display: 'flex',
          height: '100%',
          borderRadius: '0 0 4px 0',
        }}
      >
        <AeEditStatus />
        <AeCodeEditor
          error={error}
          isLoading={isLoading || isLoadingAeContent || isPageLoading}
          backgroundColor={palette.background.paper}
          showShadows={false}
        />
      </Box>
      <InvalidateLayoutsModelAndContent />
    </Stack>
  );
};
